import { combineReducers } from 'redux';
import { zendeskTicketsReducer } from './tickets/ticket.reducer';

export const zendeskReducer = combineReducers({
  tickets: zendeskTicketsReducer,
});
